// extracted by mini-css-extract-plugin
var _1 = "GoogleDrivePicker-module__animateUploadProgressBarWidth--5LRaf";
var _2 = "GoogleDrivePicker-module__animatedBackground--Vzqv2";
var _3 = "GoogleDrivePicker-module__buttons--vzW2S";
var _4 = "GoogleDrivePicker-module__content--jqhZy";
var _5 = "GoogleDrivePicker-module__modal--ZTqrY";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "buttons", _4 as "content", _5 as "modal" }
